import { OAuth2AuthenticateOptions } from '@byteowls/capacitor-oauth2';

export const oauth2Config: OAuth2AuthenticateOptions = {
  appId: "frontend", // Keycloak client ID
  authorizationBaseUrl: "https://keycloak.as2alni.com/realms/askme/protocol/openid-connect/auth",
  accessTokenEndpoint: "https://keycloak.as2alni.com/realms/askme/protocol/openid-connect/token",
  scope: "openid profile email",
  responseType: "code",
  pkceEnabled: true,
  redirectUrl: "askmeapp://callback",
  web: {
    redirectUrl: "https://as2alni.com/auth/callback",
    windowOptions: "height=600,left=0,top=0"
  },
  android: {
    appId: "frontend",
    responseType: "code",
  },
  ios: {
    appId: "frontend",
    responseType: "code",
  }
};
